import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "panel"]
  static values = {
    active: String,  // Current active tab value
  }
  static classes = [
    "triggerActive",      // Active trigger styling
    "triggerInactive",    // Inactive trigger styling
    "contentActive",      // Active content styling
    "contentInactive"     // Inactive content styling
  ]

  connect() {
    // Initialize with default active tab
    if (!this.activeValue && this.triggerTargets.length > 0) {
      this.activeValue = this.triggerTargets[0].dataset.tabsValue
    }
    this.showActiveTab()
  }

  switch(event) {
    const trigger = event.currentTarget

    // Check if disabled
    if (trigger.hasAttribute("data-tabs-disabled")) {
      event.preventDefault()
      return
    }

    // Update active value
    this.activeValue = trigger.dataset.tabsValue
    this.showActiveTab()
  }

  showActiveTab() {
    // Update triggers to active/inactive
    this.triggerTargets.forEach(trigger => {
      const isActive = trigger.dataset.tabsValue === this.activeValue

      trigger.setAttribute("aria-selected", isActive)

      if (isActive) {
        trigger.classList.remove(...this.triggerInactiveClasses)
        trigger.classList.add(...this.triggerActiveClasses)
      } else {
        trigger.classList.remove(...this.triggerActiveClasses)
        trigger.classList.add(...this.triggerInactiveClasses)
      }
    })

    // Update panels to shown/hidden
    this.panelTargets.forEach(panel => {
      const shouldShow = panel.dataset.tabsValue === this.activeValue

      if (shouldShow) {
        panel.classList.remove(...this.contentInactiveClasses)
        panel.classList.add(...this.contentActiveClasses)
        panel.removeAttribute("hidden")
      } else {
        panel.classList.remove(...this.contentActiveClasses)
        panel.classList.add(...this.contentInactiveClasses)
        panel.setAttribute("hidden", "")
      }

      panel.setAttribute("aria-hidden", !shouldShow)
    })
  }
}
